<label [for]="this.specificConfig.id + 'autocomplete'">Cerca e seleziona un valore</label>
<div [id]="this.specificConfig.id + 'autocomplete-container'"></div>
